import { SearchSeriesPayload, SeriesWarningEnum } from '../../../store/series/types';
import { SeriesListParams, WarningFilterToEnum } from '../types';

const SEARCH_MIN_CHARS = 2;

const WARNING_FILTER_TO_ENUM: WarningFilterToEnum = {
  missingOutcome: SeriesWarningEnum.OUTCOME_MISSING,
  missingFollowup: SeriesWarningEnum.FOLLOWUP_MISSING,
  ratioExceeded: SeriesWarningEnum.RATIO_EXCEEDED,
};

export function buildPayload(listParams: SeriesListParams): SearchSeriesPayload {
  const trimmed = listParams.search.trim();
  const payload: SearchSeriesPayload = {
    archived: listParams.archived,
    sort: listParams.sortMode === 'alpha' ? 'name' : 'lastAppointmentAt',
  };

  if (trimmed.length >= SEARCH_MIN_CHARS) {
    payload.q = trimmed;
  }

  if (listParams.warnings.length > 0) {
    const enumWarnings: SeriesWarningEnum[] = [];
    for (let warningsIndex = 0; warningsIndex < listParams.warnings.length; warningsIndex += 1) {
      enumWarnings.push(WARNING_FILTER_TO_ENUM[listParams.warnings[warningsIndex]]);
    }
    payload.warnings = enumWarnings;
  }

  return payload;
}
